var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconMarketplace48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19905)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9506 16.0029V37.1594H10.0493L10.0493 15.8587",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9506 16.0029V37.1594H10.0493L10.0493 15.8587",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9551 27.4858H23.1582V37.1595H26.9551V27.4858Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.045 27.4858H14.457V31.9528H19.045V27.4858Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9309 27.4858H26.9556V37.1595H33.9309V27.4858Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 15.8809H13.2009V19.052C13.2009 21.0404 11.5889 22.6524 9.60046 22.6524C7.61198 22.6524 6 21.0404 6 19.052V15.8809Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2012 15.8809H20.4021V19.052C20.4021 21.0404 18.7901 22.6524 16.8016 22.6524C14.8132 22.6524 13.2012 21.0404 13.2012 19.052V15.8809Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4019 15.8809H27.6028V19.052C27.6028 21.0404 25.9908 22.6524 24.0023 22.6524C22.0138 22.6524 20.4019 21.0404 20.4019 19.052V15.8809Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6025 15.8809H34.8035V19.052C34.8035 21.0404 33.1915 22.6524 31.203 22.6524C29.2145 22.6524 27.6025 21.0404 27.6025 19.052V15.8809Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8037 15.8809H42.0046V19.052C42.0046 21.0404 40.3926 22.6524 38.4042 22.6524C36.4157 22.6524 34.8037 21.0404 34.8037 19.052V15.8809Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0384 11.8467H36.9605C37.507 11.8467 37.9501 12.2897 37.9501 12.8363V15.8774H10.0488V12.8363C10.0488 12.2897 10.4919 11.8467 11.0384 11.8467Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconMarketplace48);
export default __webpack_public_path__ + "static/media/pictogramBeaconMarketplace48.6a04eb30c57cec08de1501da3defe97b.svg";
export { ForwardRef as ReactComponent };